export default __webpack_public_path__ + "static/media/DisabledActiveBox.5f3c3be4.svg";